// import React from "react";
// import { Navigate } from "react-router-dom";
// import { hasPermission } from "../../Utills/permission";

// const ProtectedRoute = ({ children, feature }) => {

//   const user = JSON.parse(localStorage.getItem("admin_token_info"));

//   const role = user?.role;
//   const plan = user?.package;

//   if (!hasPermission(role, plan, feature)) {
//     return <Navigate to="/unauthorized" replace />;
//   }

//   return children;
// };

// export default ProtectedRoute;

import React from "react";
import { Navigate } from "react-router-dom";
import { hasPermission } from "../../Utills/permission";
import { roleMap, packageMap } from "../../Utills/enums";

const ProtectedRoute = ({ children, feature }) => {
  // Token read karein
  const user = JSON.parse(localStorage.getItem("admin_token_info"));

  // Agar user logged in nahi hai, toh login page par bhej dein
  if (!user) {
    return <Navigate to="/" replace />; 
  }

  // Enums mapping check jo hum Layout/Router me use kar rahe hain
  const role = roleMap[user?.roleId];
  const plan = packageMap[user?.packageId];

  // Permission Verification
  if (!hasPermission(role, plan, feature)) {
    // Agar page allowed nahi hai, toh usey main entry path or PageNotFound par redirect kar dein
    return <Navigate to="/" replace />; 
  }

  return children;
};

export default ProtectedRoute;